module.exports = __webpack_public_path__ + "static/Hodlur-aa865c8c9771126bc93f8b175e5b643b.png";